import React from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { deleteAgent } from 'api/agents';
import Popup from 'components/Popup';
import Button from 'components/Button';

export default function AgentsPopupRemove({
    visible,
    setVisible,
    agent
}) {

    const cache = useQueryClient();

    const { mutate: remove } = useMutation({
        mutationKey: ['deleteAgent'],
        mutationFn: deleteAgent,
        onSuccess: () => {
            cache.invalidateQueries(['agents']);
            return setVisible(false);
        },
        onError: (error) => {
            console.error("Error removing agent:", error);
        }
    });

    function onSubmitHandler(e) {
        e.preventDefault();
        
        return remove({
            id: agent._id,
        });
    }

    if(!visible) return null;

    return (
        <Popup
            visible={visible}
            setVisible={setVisible}
        >
            <div>
                <p className=''>Sei sicuro di voler eliminare questo agente? Questa azione non può essere annullata.</p>

                <div className='flex justify-between gap-4 mt-6'>
                    <div onClick={() => setVisible(false)} className='hover:bg-verylight cursor-pointer px-4 py-3 text-sm rounded-sm'>
                        Annulla
                    </div>
                    <Button onClick={onSubmitHandler} className='bg-red-600'>Elimina</Button>
                </div>
            </div>
        </Popup>
    )
}
